import {
  DebugGrid,
  getGridGutter,
  getGridSpan,
  getGridSpans,
  maxContentWidth,
  flexContainer,
  gridContainer,
  setGridColumns,
  getGridColumns,
  getGridRows
} from './grid';
import { getSpace, getFixedSpace } from './spacings';
import getTextType from './typo';
import {
  btnReset,
  centerChildren,
  cover,
  ellipsis,
  getColor,
  hideVisually,
  mq,
  px2rem,
  hexToRgbA,
  getTransition,
  emulateFocus
} from './utility';

export {
  btnReset,
  centerChildren,
  cover,
  DebugGrid,
  ellipsis,
  getColor,
  getSpace,
  getFixedSpace,
  getTextType,
  getTransition,
  hideVisually,
  emulateFocus,
  mq,
  px2rem,
  hexToRgbA,
  getGridGutter,
  getGridSpan,
  getGridSpans,
  maxContentWidth,
  flexContainer,
  gridContainer,
  setGridColumns,
  getGridColumns,
  getGridRows
};

/**
 * Sets futurium border shape
 * @param  {string} [color] - color of border (Default: '#000')
 * @param  {string} [hoverColor] - hover color of border (Default: null)
 * @param  {string} [textColor] - hover color of text (Default: null)
 * @return {string} Resulting styling string
 */
export const borderShape = (color = '#000', hoverColor, textColor) => `
  background-color: transparent;
  background-image: linear-gradient(180deg, ${color}, ${color}), linear-gradient(225deg, ${color}, ${color}),
    linear-gradient(0deg, ${color}, ${color}), linear-gradient(90deg, ${color}, ${color}),
    linear-gradient(135deg, transparent 7px, ${color} 7px, ${color} 9px, transparent 9px);
  background-position: top right, top right, bottom left, bottom left, top left;
  background-size: calc(100% - 10px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 10px), 15px 15px;
  background-repeat: no-repeat;

  ${
    hoverColor
      ? `
    &:hover {
      background-color: transparent;
      background-image: linear-gradient(180deg, ${hoverColor}, ${hoverColor}), linear-gradient(225deg, ${hoverColor}, ${hoverColor}),
        linear-gradient(0deg, ${hoverColor}, ${hoverColor}), linear-gradient(90deg, ${hoverColor}, ${hoverColor}),
        linear-gradient(135deg, transparent 7px, ${hoverColor} 7px, ${hoverColor} 9px, transparent 9px);
      background-position: top right, top right, bottom left, bottom left, top left;
      background-size: calc(100% - 10px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 10px), 15px 15px;
      background-repeat: no-repeat;
      ${textColor ? `color: ${textColor}` : ''}
    }`
      : ''
  }
`;

/**
 * Sets futurium background shape
 * @param  {string} color - color of background (Default: '#000')
 * @param  {string} hoverColor - hover color of background (Default: null)
 * @param  {string} textColor - hover color of text (Default: null)
 * @return {string} Resulting styling string
 */
export const backgroundShape = (color = '#000', hoverColor, textColor) => `
  background: linear-gradient(135deg, transparent 7px, ${color} 0) top left;

  ${
    hoverColor
      ? `
    &:hover {
      background: linear-gradient(135deg, transparent 7px, ${hoverColor} 0) top left;
      ${textColor ? `color: ${textColor}` : ''}
    }`
      : ''
  }
`;

export const borderClipPath = (borderColor, backgroundColor) => `
  background: ${borderColor};
  border-radius: 6px;
  clip-path: polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px);

  &:after {
    position: absolute;
    background: ${backgroundColor};
    content: '';
    top: 2px;
    left: 2px;
    bottom: 2px;
    right: 2px;
    border-radius: 5px;

    clip-path: polygon(9px 0, 100% 0, 100% 100%, 0 100%, 0 9px);
  }
`;

export const backgroundClipPath = (backgroundColor, angleSize) => `
  background: ${backgroundColor};
  border-radius: 6px;
  clip-path: polygon(${angleSize || '10px'} 0, 100% 0, 100% 100%, 0 100%, 0 ${angleSize || '10px'});
`;
